import styled from 'styled-components';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { COLORS } from 'utils/styles/colors';
import { FONTS } from 'utils/styles';
import { NOT_BLOCKED, ON } from 'admin/utils/contants';

export const TableWrapper = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  min-height: 670px;

  .p-paginator .p-paginator-pages .p-paginator-page {
    background: ${COLORS.whiteLite};
    color: ${COLORS.mainColor};
    border: unset;
    height: 24px;
    margin: 2px;
    transition: unset;
    border-radius: 4px;
  }

  .p-paginator {
    justify-content: end;
    border: unset !important;
  }

  .p-paginator .p-paginator-pages .p-paginator-page:not(.p-highlight):hover {
    background: unset;
    border-color: unset;
    color: unset;
  }

  .p-link:focus {
    outline: unset;
    outline-offset: unset;
    box-shadow: unset;
  }

  .p-paginator .p-paginator-first,
  .p-paginator .p-paginator-last {
    display: none;
  }

  .p-paginator-prev,
  .p-paginator-next {
    width: 24px !important;
    border-radius: 4px;
    min-width: unset;
    height: 24px !important;
    background: #ebebeb !important;
  }

  .p-column-title {
    text-transform: capitalize;
  }

  .p-paginator .p-paginator-pages .p-paginator-page.p-highlight {
    background: ${COLORS.mainColor};
    color: ${COLORS.white};
    width: 24px !important;
    border-radius: 4px;
    min-width: unset;
    height: 24px !important;
  }

  .p-paginator .p-paginator-pages .p-paginator-page {
    min-width: 24px;
  }

  .p-datatable {
    position: unset;
  }

  .p-datatable .p-paginator-bottom {
    position: absolute;
    bottom: 0;
    width: 100%;
    justify-self: flex-end;
    align-self: flex-end;
  }

  .p-checkbox .p-checkbox-box.p-highlight {
    border-color: ${COLORS.mainColor} !important;
    background: ${COLORS.mainColor} !important;
  }
`;

export const ColumnTable = styled(Column)`
  z-index: 2;
`;

export const Table = styled(DataTable)``;

export const DefaultSpan = styled.span`
  background: ${({ buttonStyle }) =>
    buttonStyle === NOT_BLOCKED ? COLORS.green : COLORS.red};
  display: flex;
  justify-content: center;
  align-items: center;
  width: 62px;
  height: 24px;
  border-radius: 4px;
  color: ${COLORS.white};
  ${FONTS.font16};
  text-transform: capitalize;
`;

export const DefaultSecondSpan = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 62px;
  height: 24px;
  border-radius: 4px;
  color: ${({ buttonStyle }) => (buttonStyle === ON ? COLORS.green : COLORS.red)};
  ${FONTS.font16};
`;

export const TableImageContainer = styled.div`
  img {
    cursor: pointer;
  }

  display: flex;
  gap: 10px;
`;
